import kaplay from 'kaplay'

const k = kaplay({
  scale: 4,
  global: false,
  width: 180,
  height: 120
})

export default k
